import { FlagTypes } from '../enums';

export const MENTOR_FLAG_IMPACT: Record<FlagTypes, number> = {
  [FlagTypes.FIRST_MEETING_NOT_HELD_IN_10_DAYS]: 5,
  [FlagTypes.FIRST_MEETING_NOT_SCHEDULED_IN_5_DAYS]: 4,
  [FlagTypes.NO_MEETING_SCHEDULED_AFTER_48_HOURS_SIENCE_LAST_MEETING_HELD]: 3,
  [FlagTypes.NEXT_MEETING_FURTHER_THAN_62_DAYS]: 3,
  [FlagTypes.MEETING_ATTENDANCE_ISSUES]: 3,
  [FlagTypes.LOW_PARENT_SESSION_FEEDBACK]: 3,
  [FlagTypes.FIRST_MEETING_NOT_HELD_IN_7_DAYS]: 2,
  [FlagTypes.NO_FEEDBACK_AFTER_48_HOURS_SINCE_MEETING_HELD]: 2,
  [FlagTypes.BILLABLE_TIME_LESS_THAN_50_MINUTES]: 2,
  [FlagTypes.LOW_NPS]: 2,
  [FlagTypes.DISENGAGED_USER]: 2,
  [FlagTypes.MAX_DURATION_COURSE_EXCEEDED]: 2,
  [FlagTypes.FIRST_MEETING_NOT_SCHEDULED_IN_3_DAYS]: 1,
  [FlagTypes.ENROLLMENT_NOT_ENDED_AFTER_LAST_SESSION]: 1,
  [FlagTypes.NO_UNI_CHOICES_COMPLETED]: 1,
  [FlagTypes.NO_ADMISSION_RESULTS_COMPLETED]: 1,
  [FlagTypes.MENTOR_CHANGED]: 0,
  [FlagTypes.PAST_MEETING_WITH_INVALID_STATUS]: 0,
  [FlagTypes.SESSION_STATUS_MISMATCH]: 0,
  [FlagTypes.MEETING_ENDED_WITHOUT_END_TIME]: 0,
};

export const MENTOR_FLAG_IMPACT_NOTES: Partial<Record<FlagTypes, string>> = {
  [FlagTypes.MENTOR_CHANGED]:
    'Scored separately under "Mentor changes" from the enrollment history',
  [FlagTypes.PAST_MEETING_WITH_INVALID_STATUS]: 'Data integrity flag, not attributed to the mentor',
  [FlagTypes.SESSION_STATUS_MISMATCH]: 'Data integrity flag, not attributed to the mentor',
  [FlagTypes.MEETING_ENDED_WITHOUT_END_TIME]: 'Data integrity flag, not attributed to the mentor',
  [FlagTypes.FIRST_MEETING_NOT_SCHEDULED_IN_3_DAYS]: 'Deprecated early warning, kept at low weight',
  [FlagTypes.FIRST_MEETING_NOT_HELD_IN_7_DAYS]: 'Deprecated early warning, kept at low weight',
};

export const MENTOR_FLAG_IMPACT_PER_STUDENT_LIMIT = 5;
